import { ConvertLocalToUtc, FormatDate, GetCurrentDateAndTime } from "commonFunctions/commonFunctions";
import React, { useEffect, useState, useContext } from "react";
import { DocumentDetailContext } from "pages/DocumentDetail/contexts/DocumentDetailContext";
import dayjs from 'dayjs';
import * as c from "../../../../utils/constants/constants";
import CustomDatePicker from "../../../../components/CustomDatePicker/CustomDatePicker";
import { Grid } from "@mui/system";
import api from "utils/api/api";
import { EhrAppointmentsTable } from ".";
const Appointments = (props) => {
    const { setDocumentData, data = {}, setDataSave } = useContext(DocumentDetailContext);
    const [appointmentFilters, setAppointmentFilters] = useState(null);
    const [dateError, setDateError] = useState(false);
    const [pagination, setPagination] = useState({ recordsPerPage: 50, currentPage: 0, totalRecords: 0, startRecord: 0 });
    const [appointmentData, setAppointmentData] = useState([]);
    const [displayData, setDisplayData] = useState([]);
    const [appointmentLoader, setAppointentLoader] = useState(true);

    useEffect(() => {
        props.setSelectedEncApp(props.selected || null);

        if (JSON.parse(localStorage.getItem(c.APP_DATA))) {
            let filters = JSON.parse(localStorage.getItem(c.APP_DATA));
            setAppointmentFilters({...filters});
        } else {
            const defaultDates = {
                fromDate: FormatDate({ date: dayjs().subtract(1, "month"), format: "MM/DD/YYYY" }),
                toDate: FormatDate({ date: dayjs().add(1, "month"), format: "MM/DD/YYYY" })
            };
            setAppointmentFilters({...defaultDates});
        }
    }, []);

    useEffect(() => {
        props.setSelectedEncApp(props.selected || null);
    }, [props.selected]);

    useEffect(() => {
        setPagination(() => {
            return {
                ...pagination,
                totalRecords: appointmentData?.length || 0
            }
        });

    }, [appointmentData]);

    useEffect(() => {
        filterData();
    }, [pagination, appointmentData]);

    useEffect(() => {
        if (appointmentFilters) {
            getPatientsAppointments()
        }
    }, [appointmentFilters]);

    const sortByDate = (data) => {
        var res = "";
        res = data.sort((a, b) => {
            let start = a["start"] && new Date(a["start"]), end = b["start"] && new Date(b["start"]);
            if (start < end) return 1;
            if (start > end) return -1;
            return 0;
        }
        );
        return res;
    };

    const getPatientsAppointments = async () => {
        localStorage.setItem(c.APP_DATA, JSON.stringify(appointmentFilters));
        setAppointmentData(null);
        setAppointentLoader(true);
        var query = {
            doc_id: data.ID,
            do_status_filter: true,
            // status:appFilter.status,
            start_date: appointmentFilters.fromDate ? ConvertLocalToUtc({ date: appointmentFilters.fromDate, format: "MM-DD-YYYY HH:mm:ss", startOf: "day" }) : "",
            end_date: appointmentFilters.toDate ? ConvertLocalToUtc({ date: appointmentFilters.toDate, format: "MM-DD-YYYY HH:mm:ss", endOf: "day" }) : "",
        };
        await api
            .appointmentList(query)
            .then((response) => {
                if (response.status === 200) {
                    let data = sortByDate(response.data.data);
                    data.forEach((m, i) => {
                        m.s_no = i + 1;
                    });
                    setAppointmentData(data);
                    setAppointentLoader(false);
                }
            })
            .catch((error) => {
                setAppointentLoader(false);
            });
    }

    const handleDate = (date, value) => {
        if (date === "from") {
            setAppointmentFilters(prevState => {
                return { ...prevState, fromDate: value }
            });
        }
        else {
            setAppointmentFilters(prevState => {
                return { ...prevState, toDate: value }
            });
        }

    };
    const resetFilter = () => {
        setAppointmentFilters({ fromDate: "", toDate: "" });
    };

    const handleAppointmentSelection = (event, data) => {
        if (event.target.checked) {
            props.setSelectedEncApp(data.identifier)
        } else
            props.setSelectedEncApp(null);
    };

    const handleChangePage = (event, pageNum) => {
        setPagination(() => {
            return {
                ...pagination,
                currentPage: pageNum,
                startRecord: pageNum * pagination.recordsPerPage
            }
        });
    }

    const filterData = () => {
        let data = (appointmentData || []).slice(pagination.startRecord, pagination.startRecord + pagination.recordsPerPage);
        setDisplayData(data);
    }

    const handleSubmit = () => {
        let selected = appointmentData.find(m => m.identifier == props.selected);
        let finalObj = {
            "identifier": selected?.identifier,
            "period": { "start": selected?.start },
            "type": selected?.status?.charAt(0).toUpperCase() + selected?.status?.slice(1),
            "value": "appointment"
        }

        let result = { ...data }
        if (!result.Entity_Details.ehrDetails) result.Entity_Details.ehrDetails = { encounter: { [props.selected]: finalObj } }
        else result.Entity_Details.ehrDetails.encounter = { [props.selected]: finalObj };
        setDocumentData({ ...result });
        props.setEhrPopup(false);
        setDataSave(true);

    }

    const handleCancel = () => {
        props.setEhrPopup(false);
    }

    return <>
        <div className={appointmentLoader ? "block-area-common appointment-filters" : "appointment-filters"}>
            <div>Appoinments Start Dates: </div>
            <div className="appointment-filter-fields">
                <Grid style={{ paddingRight: "10px", marginLeft: "10px" }}>
                    <CustomDatePicker
                        maxDate={GetCurrentDateAndTime("MM/DD/YYYY")}
                        onChange={val => {
                            setDateError(false);
                            handleDate("from", val)
                        }}
                        onError={error => {
                            if (error) setDateError(true);
                            else setDateError(false);
                        }}
                        label="From"
                        format={'MM/DD/YYYY'}
                        variant="standard"
                        id="fromDate"
                        type="date"
                        value={appointmentFilters?.fromDate ? FormatDate({ date: appointmentFilters.fromDate, format: "MM/DD/YYYY" }) : ""}
                        name="fromDate"
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </Grid>
                <Grid style={{ paddingRight: "10px" }}>
                    <CustomDatePicker
                        minDate={FormatDate({ date: appointmentFilters?.fromDate, format: "MM/DD/YYYY" })}
                        maxDate={dayjs().add(3, "month").format("MM/DD/YYYY")}
                        onChange={val => {
                            setDateError(false);
                            handleDate('to', val);
                        }}
                        onError={error => {
                            if (error) setDateError(true);
                            else setDateError(false);
                        }}
                        disableFuture={false}
                        value={appointmentFilters?.toDate ? FormatDate({ date: appointmentFilters.toDate, format: "MM/DD/YYYY" }) : ""}
                        label="To"
                        format={'MM/DD/YYYY'}
                    />
                </Grid>
            </div>
            <div className="buttons-filter">
                <button
                    className="reset-button"
                    type="submit"
                    onClick={resetFilter}
                    style={{ width: "unset" }}
                >
                    <p className="reset-button-text">Get All Appoinments</p>
                </button>
            </div>
        </div>
        <br />
        <EhrAppointmentsTable
            loader={appointmentLoader}
            documentLevel={data?.Entity_Details?.classify?.documentLevel}
            appointmentData={displayData}
            pagination={pagination}
            selectedAppointment={props.selected}
            handleChangePage={handleChangePage}
            handleAppointmentSelection={handleAppointmentSelection}
        />
        {props.selectedTab === 2 && data?.Entity_Details?.classify?.documentLevel === "Encounter" && (
            <div className="div-center">
                <button
                    className="apply-button"
                    type="submit"
                    onClick={handleSubmit}
                >
                    <p className="apply-button-text">Done</p>
                </button>
                <button
                    className="reset-button"
                    type="submit"
                    onClick={handleCancel}
                >
                    <p className="reset-button-text">Cancel</p>
                </button>
            </div>
        )}
    </>
}

export default Appointments;